"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventListAvailable = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var storybook_1 = require("@eyecons/storybook");
var EventListAvailable = function (_a) {
    var canSelect = _a.canSelect, _b = _a.items, items = _b === void 0 ? [] : _b, onSelect = _a.onSelect, selectedEvent = _a.selectedEvent;
    return (react_1.default.createElement("div", { className: 'storybook-producer-ela' }, items.map(function (eventItemProps, index) {
        return react_1.default.createElement(storybook_1.Producer.EventItemAvailable, __assign({ key: index, canSelect: canSelect, onSelect: function () { return onSelect(eventItemProps); }, isSelected: eventItemProps.event_template_id === selectedEvent.event_template_id }, eventItemProps));
    })));
};
exports.EventListAvailable = EventListAvailable;
exports.EventListAvailable.propTypes = {
    canSelect: prop_types_1.default.bool,
    items: prop_types_1.default.array,
    onSelect: prop_types_1.default.func,
    selectedEvent: prop_types_1.default.object
};
exports.EventListAvailable.defaultProps = {
    canSelect: false,
    items: [],
    onSelect: function () { },
    selectedEvent: {}
};
